import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import React, { cloneElement, Component } from 'react';
import { withRouter } from 'react-router-dom';

import './BankContainer.scss';

import { moduleActions } from '../../redux/modules';
import If from '../../components/Shared/If/If';
import Loader from '../../components/Shared/Loader/Loader';
import { getLastPlaidFailure } from '../../redux/modules/linkedBanks/linkBank.selectors';
import { getLastEverifyFailure } from '../../redux/modules/eVerification/eVerification.selectors';
import { getSelectedBank } from '../../redux/modules/bankSelection/bankSelection.selectors';
import { getEligibleBanks } from '../../redux/modules/existingBanks/existingBanks.selectors';
import {
  ADD_BANK_MODAL,
  openModal,
} from '../../redux/modules/modals/modals.module';
import { getEligibleAgreementsList } from '../../redux/modules/eligibleAgreements/eligibleAgreements.module';
require('animate.css/animate.min.css');

export class BankContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      exiting: false,
    };
    this.handleExit = this.handleExit.bind(this);
  }

  componentDidMount() {
    const {
      actions: {
        getExistingBanks,
        getFailureHistory,
        getPersonalInformation,
        getProductTypes,
      },
      dispatch,
    } = this.props;
    const standalone = window.location.pathname.includes('addbank');
    dispatch(getEligibleAgreementsList());
    if (standalone) {
      getPersonalInformation();
      getExistingBanks();
      dispatch(getProductTypes());
    }
    getFailureHistory();
  }

  handleExit() {
    this.setState({ exiting: true });
  }

  render() {
    const { children, ...rest } = this.props;
    const standalone = window.location.pathname.includes('addbank');
    return (
      <div className={`bank-container ${standalone ? 'standalone' : ''}`}>
        <If test={this.state.exiting}>
          <div className="bank-container-bank-loader-wrapper">
            <Loader isVisible={this.state.exiting} />
            <div className="bank-container-loader-label">Loading</div>
          </div>
        </If>
        {React.Children.map(children, (child) =>
          cloneElement(child, {
            handleExit: this.handleExit,
            standalone: standalone,
            ...rest,
          })
        )}
        <div className="clear" />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  authentication: state.authentication,
  bankSelection: state.bankSelection,
  eligibleBanks: getEligibleBanks(state),
  existingBanks: state.existingBanks,
  eVerification: state.eVerification,
  lastEverifyFailure: getLastEverifyFailure(state),
  lastPlaidFailure: getLastPlaidFailure(state),
  linkedBanks: state.linkedBanks,
  personalInformation: state.personalInformation,
  routing: state.routing,
  selectedBank: getSelectedBank(state),
  shoppingCart: state.shoppingCart,
  user: state.user,
  userProductTypes: state.userProductTypes,
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(moduleActions, dispatch),
  openAddBankModal: () => dispatch(openModal(ADD_BANK_MODAL)),
  dispatch,
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withRouter
)(BankContainer);
